/* eslint-disable import/prefer-default-export */
export enum StepTypes {
  USER_INFORMATION,
  ALERT_SETTINGS,
  REVIEW_INFORMATION
}
